import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import BusinessTabs from "examples/Tabs/BusinessTabs";

function CookWear() {
  return (
    <DashboardLayout>
      <BusinessTabs />
    </DashboardLayout>
  );
}

export default CookWear;